import React from "react";
import { Link } from "react-router-dom";
import articles from "../../data/articles";
import "./Blogs.css";

const Blogs = () => (
  <section className="thas-blog-index" aria-labelledby="blog-heading">
    <div className="site-container">
      <nav className="thas-blog-breadcrumb" aria-label="Brödsmulor">
        <ol>
          <li><Link to="/">Hem</Link></li>
          <li aria-current="page">Kunskap & guider</li>
        </ol>
      </nav>
      <header className="thas-blog-intro">
        <p className="site-eyebrow">KUNSKAP & GUIDER</p>
        <h1 id="blog-heading">Lite mer koll på<br /><em>företagets ekonomi.</em></h1>
        <p>Praktiska råd om bokföring och redovisning, för dig som vill förstå siffrorna och skapa bättre rutiner i vardagen.</p>
      </header>
      <div className="thas-blog-cards">
        {articles.map((article, index) => (
          <article className="thas-blog-card" key={article.path}>
            <Link to={article.path} className="thas-blog-card-link" aria-labelledby={`article-title-${index}`}>
              <div className="thas-blog-card-category">
                <span>{article.category}</span>
                <span aria-hidden="true">0{index + 1}</span>
              </div>
              <h2 id={`article-title-${index}`}>{article.title}</h2>
              <p>{article.description}</p>
              <span className="thas-blog-card-action">Läs guiden <span aria-hidden="true">↗</span></span>
            </Link>
          </article>
        ))}
      </div>
      <aside className="thas-blog-help" aria-labelledby="blog-help-heading">
        <div>
          <h2 id="blog-help-heading">Vill du prata om ditt företag?</h2>
          <p>Berätta vad du behöver hjälp med, så tar vi nästa steg tillsammans.</p>
        </div>
        <Link to="/#contact" className="site-button">Kontakta oss <span aria-hidden="true">↗</span></Link>
      </aside>
    </div>
  </section>
);

export default Blogs;